import { TabStyles } from '@tableau/widgets';
import { CommonStyles } from '../../common/react/CommonStyles';
import { cssClass } from '../../style';

const cssPrefix = 'Home';

export namespace HomeStyles {

  export const root = cssClass(cssPrefix, 'root', {
    fontFamily: CommonStyles.Fonts.HeaderFont,
    margin: '32px 24px 0',
    position: 'relative',
    overflowX: 'hidden'
  });

  export const pageHeader = cssClass(cssPrefix, 'page-header', {
    marginBottom: 44,
    $nest: {
      '& h1': {
        color: TabStyles.Colors.L9,
        fontSize: TabStyles.Typography.Sizing.XXLarge,
        fontFamily: CommonStyles.Fonts.HeaderFont,
        margin: 0,
        fontWeight: 400,
        lineHeight: 1
      }
    }
  });

  export const contentSection = cssClass(cssPrefix, 'content-section', {
    marginBottom: 56
  });

  export const createButton = cssClass(cssPrefix, 'create-button', {
    position: 'absolute',
    top: '0',
    right: '0',
  });

  export const link = cssClass(cssPrefix, 'link', {
    color: CommonStyles.Colors.HyperlinkBlue,
    fontFamily: CommonStyles.Fonts.HeavyFont,
    fontSize: TabStyles.Typography.Sizing.Default,
  });

}
